import { UniteTypeMarket } from '~/generated/payoutBackend/model';

export const markets = Object.values(UniteTypeMarket)
    .filter((c) => c !== UniteTypeMarket.MARKET_UNSPECIFIED)
    .map((value) => ({
        value,
        label: value.replace('MARKET_', '').replaceAll('_', ''),
    }));
